import { render, staticRenderFns } from "./SectionCarryMaterialGroup.vue?vue&type=template&id=366f8a7a&scoped=true"
import script from "./SectionCarryMaterialGroup.vue?vue&type=script&lang=js"
export * from "./SectionCarryMaterialGroup.vue?vue&type=script&lang=js"
import style0 from "./SectionCarryMaterialGroup.vue?vue&type=style&index=0&id=366f8a7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f8a7a",
  null
  
)

export default component.exports